import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  template: `
    <div class="lds-css ng-scope">
      <div class="lds-double-ring">
        <div></div>
        <div></div>
        <div><div></div></div>
        <div><div></div></div>
      </div>
    </div>
  `,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {}
